import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { tap } from "rxjs/operators";
import { LoaderService } from "../../common/services/loader.service";
import { OrganizationService } from "../../common/services/organization.service";

@Injectable()
export class CommunicationGetOrg  {
    constructor(private orgService: OrganizationService,
        public loaderService: LoaderService) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        this.loaderService.toggleLoader(true);
        if (route.paramMap.get('orgId')) {
            var id = route.paramMap.get('orgId');
            const orgInfo = this.orgService.getOrgAndMergeFieldInfo(id).pipe(tap((data) => { this.loaderService.toggleLoader(false); }));
            return orgInfo;
        }
    }
}